import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  CircularProgress,
  Grid,
  Box,
  Card,
  Typography,
  Button,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogActions,
  Tooltip,
} from "@mui/material";
import { useGetAllPayrollRecordeDateRangeQuery } from "../../../Api/attoDeskApi";
import {
  IPayrollDateRangeList,
  IPayrollGetAllList,
} from "../../../Api/Interface/api.interface";
import { useNotifier } from "../../../Core/Notifier";
import useDebounce from "../../../Components/SearchDebonce/useDebounce";
import { useNavigate } from "react-router-dom";
import { useStyles } from "../../../theme/appStyles";
import dayjs, { Dayjs } from "dayjs";
import LocalPrintshopSharpIcon from "@mui/icons-material/LocalPrintshopSharp";
import ReactToPrint from "react-to-print";
import * as XLSX from "xlsx";
import TableViewIcon from "@mui/icons-material/TableView";
import Groups2OutlinedIcon from "@mui/icons-material/Groups2Outlined";
import { GiReceiveMoney } from "react-icons/gi";
import { FaUserClock } from "react-icons/fa";
import { Privileges } from "../../../Core/Enum/enum";
import useUser from "../../../Core/hook/useUser";
import VisibilitySharpIcon from "@mui/icons-material/VisibilitySharp";
import EditSharpIcon from "@mui/icons-material/EditSharp";
import PersonSearchRoundedIcon from "@mui/icons-material/PersonSearchRounded";
import CloseIcon from "@mui/icons-material/Close";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { faLink } from "@fortawesome/free-solid-svg-icons";
import { faUser } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import useIsMobile from "../../../Core/hook/useIsMobile";

const capitalizeFirstLetter = (name: string) =>
  name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();

const Index = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const { showErrorMessage, showMessage } = useNotifier();
  const [searchQuery, setSearchQuery] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10000);
  const debouncedSearchQuery = useDebounce(searchQuery, 300);
  const componentRef = useRef<HTMLDivElement>(null);
  const { userHasRight } = useUser();
  const [open, setOpen] = useState(false);
  const isMobileRes = useIsMobile();

  const {
    data: payrollListData,
    isLoading: payrollIsLoading,
    isError: payrollIsError,
    refetch: payrollListRefetch,
  } = useGetAllPayrollRecordeDateRangeQuery();

  const payrollSummaryDataList = useMemo(() => {
    return payrollListData?.dashboard_summary as IPayrollGetAllList;
  }, [payrollListData?.dashboard_summary]);

  const coursings: IPayrollDateRangeList[] = Array.isArray(
    payrollListData?.data
  )
    ? (payrollListData?.data as IPayrollDateRangeList[])
    : [];

  const handleOpenDialogGenerate = () => {
    setOpen(true);
  };

  const handleCloseDialogGenerate = () => {
    setOpen(false);
  };

  const handleConfirm = () => {
    setOpen(false);
    navigate("/payroll/generate");
  };

  return (
    <Grid container spacing={3}>
      {/* <Grid item lg={12} md={12} sm={12} xs={12}>
        <Grid container spacing={2}>
          <Grid item lg={4} md={12} sm={12} xs={12}>
            <Card
              className={classes.cardPrimary}
              sx={{
                padding: 2,
                height: "100%",
              }}
            >
              <Grid
                container
                justifyContent="space-between"
                alignItems="center"
              >
                <Grid item>
                  <Typography className={classes.dashboardTypograpy}>
                    Employees
                  </Typography>
                  <Typography className={classes.buttonLabelForHeading}>
                    {Number(payrollSummaryDataList?.employee_count || 0)}
                  </Typography>
                </Grid>

                <Grid item>
                  <Box className={classes.dashboardPrimary}>
                    <Groups2OutlinedIcon sx={{ fontSize: 40 }} />
                  </Box>
                </Grid>
              </Grid>
            </Card>
          </Grid>
          <Grid item lg={4} md={12} sm={12} xs={12}>
            <Card
              className={classes.cardPrimary}
              sx={{
                padding: 2,
                height: "100%",
              }}
            >
              <Grid
                container
                justifyContent="space-between"
                alignItems="center"
              >
                <Grid item>
                  <Typography className={classes.dashboardTypograpy}>
                    Hours
                  </Typography>
                  <Typography className={classes.buttonLabelForHeading}>
                    {Number(payrollSummaryDataList?.total_hours || 0).toFixed(
                      2
                    )}
                    {" hrs"}
                  </Typography>
                </Grid>

                <Grid item>
                  <Box className={classes.dashboardPrimary}>
                    <FaUserClock style={{ fontSize: 35 }} />
                  </Box>
                </Grid>
              </Grid>
            </Card>
          </Grid>
          <Grid item lg={4} md={12} sm={12} xs={12}>
            <Card
              className={classes.cardPrimary}
              sx={{
                padding: 2,
                height: "100%",
              }}
            >
              <Grid
                container
                justifyContent="space-between"
                alignItems="center"
              >
                <Grid item>
                  <Typography className={classes.dashboardTypograpy}>
                    Salary
                  </Typography>
                  <Typography className={classes.buttonLabelForHeading}>
                    {"$ "}
                    {Number(payrollSummaryDataList?.total_salary || 0).toFixed(
                      2
                    )}
                  </Typography>
                </Grid>

                <Grid item>
                  <Box className={classes.dashboardPrimary}>
                    <GiReceiveMoney style={{ fontSize: 40 }} />
                  </Box>
                </Grid>
              </Grid>
            </Card>
          </Grid>
        </Grid>
      </Grid> */}
      <Grid item lg={12} md={12} sm={12} xs={12}>
        <Grid container spacing={2}>
          <Grid item lg={4} md={4} sm={12} xs={12}>
            <Card className={classes.staffDhashboardSmallCardUpdate}>
              <Grid container spacing={2}>
                <Grid
                  item
                  lg={6}
                  md={6}
                  sm={6}
                  xs={6}
                  className={classes.dashboardfristCardGrid}
                >
                  <Box className={classes.dashboardfristCardButton}>
                    <Groups2OutlinedIcon
                      className={classes.dashboardfristCardButtonIcon}
                    />
                  </Box>
                </Grid>
                <Grid
                  item
                  lg={6}
                  md={6}
                  sm={6}
                  xs={6}
                  className={classes.dashboardfristCardGrid}
                >
                  <Typography className={classes.dashboardfristCardButtonText1}>
                    Staff
                  </Typography>
                  <Typography className={classes.dashboardfristCardButtonText2}>
                    {Number(payrollSummaryDataList?.employee_count || 0)}
                  </Typography>
                </Grid>
              </Grid>
            </Card>
          </Grid>
          <Grid item lg={4} md={4} sm={12} xs={12}>
            <Card className={classes.staffDhashboardSmallCardUpdate}>
              <Grid container spacing={2}>
                <Grid
                  item
                  lg={6}
                  md={6}
                  sm={6}
                  xs={6}
                  className={classes.dashboardfristCardGrid}
                >
                  <Box className={classes.dashboardfristCardButton}>
                    <FaUserClock
                      className={classes.dashboardfristCardButtonIcon}
                    />
                  </Box>
                </Grid>
                <Grid
                  item
                  lg={6}
                  md={6}
                  sm={6}
                  xs={6}
                  className={classes.dashboardfristCardGrid}
                >
                  <Typography className={classes.dashboardfristCardButtonText1}>
                    Hours
                  </Typography>
                  <Typography className={classes.dashboardfristCardButtonText2}>
                    {Number(payrollSummaryDataList?.total_hours || 0).toFixed(
                      2
                    )}
                    {" hrs"}
                  </Typography>
                </Grid>
              </Grid>
            </Card>
          </Grid>
          <Grid item lg={4} md={4} sm={12} xs={12}>
            <Card className={classes.staffDhashboardSmallCardUpdate}>
              <Grid container spacing={2}>
                <Grid
                  item
                  lg={6}
                  md={6}
                  sm={6}
                  xs={6}
                  className={classes.dashboardfristCardGrid}
                >
                  <Box className={classes.dashboardfristCardButton}>
                    <GiReceiveMoney
                      className={classes.dashboardfristCardButtonIcon}
                    />
                  </Box>
                </Grid>
                <Grid
                  item
                  lg={6}
                  md={6}
                  sm={6}
                  xs={6}
                  className={classes.dashboardfristCardGrid}
                >
                  <Typography className={classes.dashboardfristCardButtonText1}>
                    Salary
                  </Typography>
                  <Typography className={classes.dashboardfristCardButtonText2}>
                    {"$ "}
                    {Number(payrollSummaryDataList?.total_salary || 0).toFixed(
                      2
                    )}
                  </Typography>
                </Grid>
              </Grid>
            </Card>
          </Grid>
        </Grid>
      </Grid>
      <>{/* {isMobileRes ? ():()} */}</>
      <Grid item lg={12} md={12} sm={12} xs={12}>
        <Card className={classes.card}>
          <Grid
            container
            justifyContent={"space-between"}
            spacing={5}
            sx={{ padding: 2 }}
            className={classes.titleGrid}
          >
            {/* <Grid
              item
              lg={4}
              md={4}
              sm={4}
              xs={4}
              pt={2}
              alignContent={"center"}
            >
              <Typography className={classes.cardTitle}>
                Payroll List
              </Typography>
            </Grid> */}

            <Grid
              item
              lg={12}
              md={12}
              sm={12}
              xs={12}
              sx={{ display: "flex", justifyContent: "flex-end" }}
            >
              <Grid
                container
                spacing={1}
                justifyContent="flex-end"
                sx={{ display: "flex" }}
              >
                {userHasRight(Privileges.GeneratePayroll) && (
                  <Grid item>
                    <Button
                      className={classes.addNewButton}
                      onClick={handleOpenDialogGenerate}
                    >
                      Generate Payroll
                    </Button>
                  </Grid>
                )}
              </Grid>
            </Grid>
          </Grid>

          <Grid>
            <div ref={componentRef}>
              <TableContainer>
                <Table className={classes.table}>
                  <TableHead className={classes.tableHeaderRow}>
                    <TableRow>
                      <TableCell className={classes.tablheader}>
                        <strong>Id </strong>
                      </TableCell>

                      {!isMobileRes && (
                        <>
                          <TableCell className={classes.tablheader}>
                            <strong>Date Range </strong>
                          </TableCell>
                          <TableCell
                            className={classes.tablheader}
                            // sx={{ textAlign: "center" }}
                          >
                            <Typography>
                              <strong>Total Hours</strong>
                            </Typography>
                            <Typography>
                              <strong>(Normal / OT)</strong>
                            </Typography>
                          </TableCell>
                          <TableCell
                            className={classes.tablheader}
                            // sx={{ textAlign: "center" }}
                          >
                            <Typography>
                              <strong>Total Salary</strong>
                            </Typography>
                            <Typography>
                              <strong>(Normal / OT / Adj)</strong>
                            </Typography>
                          </TableCell>
                        </>
                      )}
                      {userHasRight(
                        Privileges.PayrollView || Privileges.GeneratePayroll
                      ) && (
                        <TableCell
                          className={classes.tablheader}
                          sx={{ textAlign: "right" }}
                        >
                          <strong>Action</strong>
                        </TableCell>
                      )}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {payrollIsLoading ? (
                      <TableRow>
                        <TableCell colSpan={20} align="center">
                          <Box
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            height="10vh"
                          >
                            <CircularProgress />
                          </Box>
                        </TableCell>
                      </TableRow>
                    ) : payrollIsError || coursings.length === 0 ? (
                      <TableRow>
                        <TableCell colSpan={20} align="center">
                          {payrollIsError
                            ? "Error fetching data"
                            : "No data available"}
                        </TableCell>
                      </TableRow>
                    ) : (
                      coursings
                        .slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage
                        )
                        .map((row: IPayrollDateRangeList, index) => (
                          <TableRow
                            key={index}
                            className={classes.tableRowHover}
                          >
                            <TableCell scope="row" className={classes.tablCell}>
                              <Link
                                to={`/payroll/list/${
                                  row.isPayrollGenerate
                                    ? row.id
                                    : `edit/${row.id}`
                                }`}
                                className={classes.iconLinkPropNormal}
                              >
                                <Typography className={classes.nameTableList}>
                                  {row.payrollGenerateId
                                    ? row.payrollGenerateId
                                    : `PR${dayjs(row.startDate).format(
                                        "DDMMYY"
                                      )}-${String(row.id).padStart(2, "0")}`}
                                  {/* <span
                                    style={{
                                      cursor: "pointer",
                                      display: "inline-flex",
                                      alignItems: "center",
                                      paddingLeft: "5px",
                                    }}
                                  >
                                    <FontAwesomeIcon
                                      icon={faLink}
                                      style={{ color: "#1976d2" }}
                                    />
                                  </span> */}
                                </Typography>
                              </Link>
                              {isMobileRes && (
                                <Typography className={classes.mobileListText}>
                                  {dayjs(row.startDate).format("MMM-DD, YYYY")}
                                  {"  -  "}
                                  {dayjs(row.endDate).format("MMM-DD, YYYY")}
                                </Typography>
                              )}
                            </TableCell>

                            {!isMobileRes && (
                              <>
                                <TableCell
                                  scope="row"
                                  className={classes.tablCell}
                                >
                                  {dayjs(row.startDate).format("MMM-DD, YYYY")}
                                  {"  -  "}
                                  {dayjs(row.endDate).format("MMM-DD, YYYY")}
                                </TableCell>
                                <TableCell
                                  scope="row"
                                  className={classes.tablCell}
                                  // sx={{ textAlign: "center" }}
                                >
                                  <Typography>
                                    {Number(row.total_hours || 0).toFixed(2)}
                                    {" hrs"}
                                  </Typography>
                                  <Typography>
                                    {"( "}
                                    {Number(
                                      row.total_normal_hours || 0
                                    ).toFixed(2)}
                                    {" hrs / "}
                                    {Number(row.total_ot_hours || 0).toFixed(2)}
                                    {" hrs"}
                                    {" )"}
                                  </Typography>
                                </TableCell>
                                <TableCell
                                  scope="row"
                                  className={classes.tablCell}
                                  // sx={{ textAlign: "center" }}
                                >
                                  <Typography>
                                    {"$ "}
                                    {Number(row.total_salary || 0).toFixed(2)}
                                  </Typography>
                                  <Typography>
                                    {"( $ "}
                                    {Number(row.gross_salary || 0).toFixed(2)}
                                    {"  / $ "}
                                    {Number(row.ot_salary || 0).toFixed(2)}
                                    {"  / $ "}
                                    {Number(row.bonus_amount || 0).toFixed(2)}
                                    {" )"}
                                  </Typography>
                                </TableCell>
                              </>
                            )}
                            <TableCell className={classes.tablCell}>
                              <Grid
                                container
                                spacing={1}
                                sx={{
                                  display: "flex",
                                  justifyContent: "flex-end",
                                }}
                              >
                                {row.isPayrollGenerate ? (
                                  <>
                                    {userHasRight(Privileges.PayrollView) && (
                                      <>
                                        <Tooltip
                                          title={
                                            <>
                                              <Typography
                                                variant="body2"
                                                key={index}
                                              >
                                                <strong>
                                                  Payroll List Details
                                                </strong>
                                              </Typography>
                                              <Typography
                                                variant="body2"
                                                key={index}
                                              >
                                                <strong>
                                                  for each Employee records
                                                </strong>
                                              </Typography>
                                            </>
                                          }
                                          sx={{ fontSize: "14px" }}
                                        >
                                          <Grid item>
                                            <Link
                                              to={`/payroll/list/emp/report/${row.id}`}
                                              className={
                                                classes.iconLinkPropNormal
                                              }
                                            >
                                              <Button
                                                // variant="contained"
                                                className={
                                                  classes.viewButtonList
                                                }
                                                onClick={() =>
                                                  navigate(
                                                    `/payroll/list/emp/report/${row.id}`
                                                  )
                                                }
                                              >
                                                <PersonSearchRoundedIcon
                                                  className={
                                                    classes.viewListIcon
                                                  }
                                                />
                                              </Button>
                                            </Link>
                                          </Grid>
                                        </Tooltip>
                                        <Tooltip
                                          title={
                                            <>
                                              <Typography
                                                variant="body2"
                                                key={index}
                                              >
                                                <strong>
                                                  View Payroll List
                                                </strong>
                                              </Typography>
                                            </>
                                          }
                                          sx={{ fontSize: "14px" }}
                                        >
                                          <Grid item>
                                            <Link
                                              to={`/payroll/list/${row.id}`}
                                              className={
                                                classes.iconLinkPropNormal
                                              }
                                            >
                                              <Button
                                                // variant="contained"
                                                className={
                                                  classes.viewButtonList
                                                }
                                                onClick={() =>
                                                  navigate(
                                                    `/payroll/list/${row.id}`
                                                  )
                                                }
                                              >
                                                <VisibilitySharpIcon
                                                  className={
                                                    classes.viewListIcon
                                                  }
                                                />
                                              </Button>
                                            </Link>
                                          </Grid>
                                        </Tooltip>
                                      </>
                                    )}
                                  </>
                                ) : (
                                  <>
                                    {userHasRight(
                                      Privileges.GeneratePayroll
                                    ) && (
                                      <Tooltip
                                        title={
                                          <>
                                            <Typography
                                              variant="body2"
                                              key={index}
                                            >
                                              <strong>Edit Payroll</strong>
                                            </Typography>
                                          </>
                                        }
                                        sx={{ fontSize: "14px" }}
                                      >
                                        <Grid item>
                                          <Link
                                            to={`/payroll/list/edit/${row.id}`}
                                            className={
                                              classes.iconLinkPropNormal
                                            }
                                          >
                                            <Button
                                              // variant="contained"
                                              className={classes.editButtonList}
                                              onClick={() =>
                                                navigate(
                                                  `/payroll/list/edit/${row.id}`
                                                )
                                              }
                                            >
                                              <EditSharpIcon
                                                className={classes.editListIcon}
                                              />
                                            </Button>
                                          </Link>
                                        </Grid>
                                      </Tooltip>
                                    )}
                                  </>
                                )}
                              </Grid>
                            </TableCell>
                          </TableRow>
                        ))
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          </Grid>
        </Card>

        <Dialog
          open={open}
          onClose={handleCloseDialogGenerate}
          sx={{ padding: 5, minWidth: 450 }}
        >
          <Grid className={isMobileRes ? classes.DialogMobile : classes.Dialog}>
            <Grid
              container
              justifyContent={"space-between"}
              spacing={5}
              sx={{ borderBottom: 2, padding: 2 }}
              className={classes.titleGrid}
            >
              <Grid
                item
                lg={12}
                md={12}
                sm={12}
                xs={12}
                pt={2}
                alignContent={"center"}
              >
                <Typography className={classes.cardTitle}>
                  Confirm Action
                </Typography>
              </Grid>
            </Grid>
            <DialogContent>
              <DialogContentText sx={{ pt: 3 }}>
                Are you sure you want to generate the payroll? This action
                cannot be undone.
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                variant="outlined"
                startIcon={<CloseIcon />}
                className={classes.addButton}
                onClick={handleCloseDialogGenerate}
              >
                Cancel
              </Button>
              <Box m={0.5}></Box>

              <Button
                onClick={handleConfirm}
                variant="contained"
                startIcon={<CheckCircleOutlineIcon />}
                className={classes.addButton}
              >
                Confirm
              </Button>
            </DialogActions>
          </Grid>
        </Dialog>
      </Grid>
    </Grid>
  );
};

export default Index;
